(function () {
  document.querySelectorAll('[data-sm-custom-form]').forEach(initCustomForm);

  // Expose card height so the sticky column (CSS) can keep the CTA on screen when the card is taller than the viewport.
  document.querySelectorAll('.sm-pd--custom .sm-pd__right').forEach((col) => {
    new ResizeObserver(() => {
      col.style.setProperty('--sm-pd-card-h', col.offsetHeight + 'px');
    }).observe(col);
  });

  function initCustomForm(form) {
    const qtyInput = form.querySelector('[data-sm-qty-input]');
    const dec = form.querySelector('[data-sm-qty-dec]');
    const inc = form.querySelector('[data-sm-qty-inc]');
    const qtyDisplay = form.querySelector('[data-sm-qty-display]');
    const variantIdInput = form.querySelector('[data-sm-variant-id]');
    const priceValueEl = form.querySelector('[data-sm-price-value]');
    const variantMapEl = form.querySelector('[data-sm-variant-map]');
    const materialInputs = form.querySelectorAll('[data-sm-material]');
    const addBtnEarly = form.querySelector('[data-sm-add]');
    const addTextEl = form.querySelector('[data-sm-add-text]');

    let variants = [];
    try {
      variants = (JSON.parse(variantMapEl.textContent) || {}).variants || [];
    } catch (e) {
      variants = [];
    }

    // Fallback thresholds, by tier position, used only when the volume-range labels
    // carry no leading number (e.g. fully spelled-out translation).
    const FALLBACK_MINS = [5, 10, 50, 100];

    const getSelectedMaterial = () => {
      const picked = Array.from(materialInputs).find((i) => i.checked);
      return picked ? picked.value : (materialInputs[0] && materialInputs[0].value);
    };

    // Picks the highest tier whose minimum quantity is still <= q. Matching on
    // tierMin (a number) instead of the tier label keeps this working in every
    // locale — the labels are translated in the admin, the numbers are not.
    const findVariant = (material, q) => {
      const tiers = variants.filter((v) => v.material === material);
      if (!tiers.length) return null;

      const withMin = tiers.map((v, i) => ({
        variant: v,
        min: Number(v.tierMin) > 0 ? Number(v.tierMin) : FALLBACK_MINS[i] || 1,
      }));
      withMin.sort((a, b) => a.min - b.min);

      const n = parseInt(q, 10) || 0;
      let picked = withMin[0];
      withMin.forEach((t) => {
        if (n >= t.min) picked = t;
      });
      return picked.variant;
    };

    const syncVariant = () => {
      if (!variants.length) return;
      const material = getSelectedMaterial();
      const match = findVariant(material, qtyInput && qtyInput.value);
      if (!match) return;
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceValueEl) priceValueEl.textContent = match.price;
      if (addBtnEarly) {
        if (match.available) {
          addBtnEarly.disabled = false;
          addBtnEarly.removeAttribute('aria-disabled');
        } else {
          addBtnEarly.disabled = true;
        }
      }
    };

    const syncQtyDisplay = () => {
      if (qtyDisplay && qtyInput) qtyDisplay.textContent = qtyInput.value;
    };
    if (qtyInput && dec && inc) {
      const min = parseInt(qtyInput.dataset.smQtyMin, 10) || 1;
      const clamp = (v) => {
        const n = parseInt(v, 10);
        return isNaN(n) || n < min ? min : n;
      };
      dec.addEventListener('click', () => {
        qtyInput.value = Math.max(min, clamp(qtyInput.value) - 1);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncQtyDisplay();
      });
      inc.addEventListener('click', () => {
        qtyInput.value = clamp(qtyInput.value) + 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncQtyDisplay();
      });
      qtyInput.addEventListener('blur', () => {
        qtyInput.value = clamp(qtyInput.value);
        syncQtyDisplay();
      });
      qtyInput.addEventListener('input', syncQtyDisplay);
      qtyInput.addEventListener('change', syncVariant);
      qtyInput.addEventListener('input', syncVariant);
    }
    syncQtyDisplay();

    materialInputs.forEach((i) => i.addEventListener('change', syncVariant));
    syncVariant();

    const colorInput = form.querySelector('[data-sm-color-input]');
    const colorText = form.querySelector('[data-sm-color-text]');
    const colorPreviewColor = form.querySelector('[data-sm-color-preview-color]');
    const colorPreviewHex = form.querySelector('[data-sm-color-preview-hex]');
    const presetColorBtns = form.querySelectorAll('[data-sm-preset-color]');
    const customColorBtn = form.querySelector('[data-sm-custom-color-btn]');
    const colorSummary = form.querySelector('[data-sm-color-summary]');
    const colorSummaryDot = form.querySelector('[data-sm-color-summary-dot]');

    if (colorInput) {
      const HEX_RE = /^#[0-9a-fA-F]{6}$/;

      const setDot = (v) => {
        if (colorPreviewColor) {
          colorPreviewColor.style.backgroundColor = v;
        }
        if (colorSummaryDot) {
          colorSummaryDot.style.backgroundColor = v;
        }
      };

      const setSummary = (v) => {
        if (colorPreviewHex) {
          colorPreviewHex.textContent = v || '—';
        }
        if (colorSummary) {
          colorSummary.textContent = v || '—';
        }
      };

      const setSelectedPreset = (value) => {
        const normalized = String(value || '').toUpperCase();

        presetColorBtns.forEach((btn) => {
          const preset = String(
            btn.dataset.smPresetColor || ''
          ).toUpperCase();

          const selected = preset === normalized;

          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      };

      const setColor = (value, selectPreset = true) => {
        if (!value) return;

        const v = String(value).toUpperCase();

        if (colorInput) {
          colorInput.value = v;
        }

        if (colorText) {
          colorText.value = v;
        }

        setDot(v);
        setSummary(v);

        if (selectPreset) {
          setSelectedPreset(v);
        }
      };

      /*
      * Preset colors
      */
      presetColorBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const value = btn.dataset.smPresetColor;

          if (!value) return;

          setColor(value, true);

          if (customColorBtn) {
            customColorBtn.classList.remove('is-selected');
          }
        });
      });

      /*
      * Custom color picker
      */
      colorInput.addEventListener('input', () => {
        const v = colorInput.value.toUpperCase();

        setDot(v);
        setSummary(v);

        if (colorText) {
          colorText.value = v;
        }

        setSelectedPreset(v);

        const matchedPreset = Array.from(presetColorBtns).some((btn) => {
          return String(btn.dataset.smPresetColor || '').toUpperCase() === v;
        });

        if (customColorBtn) {
          customColorBtn.classList.toggle('is-selected', !matchedPreset);
        }
      });

      if (customColorBtn) {
        customColorBtn.addEventListener('click', (event) => {
          if (event.target !== colorInput) {
            colorInput.click();
          }

          customColorBtn.classList.add('is-selected');
          presetColorBtns.forEach((btn) => {
            btn.classList.remove('is-selected');
            btn.setAttribute('aria-checked', 'false');
          });
        });
      }

      if (colorText) {
        const colorField = colorText.closest('.sm-sc-color-field');

        const setError = (on) => {
          if (colorField) {
            colorField.classList.toggle(
              'sm-sc-color-field--error',
              on
            );
          }
        };

        colorText.addEventListener('input', () => {
          let v = colorText.value.trim();

          if (v && v[0] !== '#') {
            v = '#' + v;

            const caret =
              (colorText.selectionStart || 0) + 1;

            colorText.value = v;
            colorText.setSelectionRange(caret, caret);
          }

          if (HEX_RE.test(v)) {
            v = v.toUpperCase();

            colorInput.value = v;

            setDot(v);
            setSummary(v);
            setSelectedPreset(v);

            const matchedPreset = Array.from(
              presetColorBtns
            ).some((btn) => {
              return (
                String(btn.dataset.smPresetColor || '').toUpperCase() === v
              );
            });

            if (customColorBtn) {
              customColorBtn.classList.toggle(
                'is-selected',
                !matchedPreset
              );
            }

            colorText.setCustomValidity('');
            setError(false);
          } else {
            colorText.setCustomValidity(
              v
                ? 'カラーコードは「#」+ 6桁で入力してください。（例：#1F4DAB）'
                : ''
            );

            if (!v) {
              setError(false);
            }
          }
        });

        colorText.addEventListener('blur', () => {
          colorText.value = colorText.value.trim();

          setError(
            !!colorText.value &&
            !HEX_RE.test(colorText.value)
          );
        });
      }

      const initialPreset = presetColorBtns[0];

      if (initialPreset) {
        const initialValue = initialPreset.dataset.smPresetColor;

        setColor(initialValue, true);

        if (customColorBtn) {
          customColorBtn.classList.remove('is-selected');
        }
      }
    }

    const fileInput = form.querySelector('[data-sm-file-input]');
    const fileName = form.querySelector('[data-sm-file-name]');
    if (fileInput && fileName) {
      const emptyLabel = fileName.textContent;
      fileInput.addEventListener('change', () => {
        const f = fileInput.files && fileInput.files[0];
        fileName.textContent = f ? f.name : emptyLabel;
      });
    }

    const addBtn = form.querySelector('[data-sm-add]');
    const addSpinner = form.querySelector('[data-sm-add-spinner]');
    if (addBtn) {
      const showLoading = () => {
        if (addBtn.getAttribute('aria-disabled') === 'true') return;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('loading');
        if (addSpinner) addSpinner.hidden = false;
      };
      const hideLoading = () => {
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.remove('loading');
        if (addSpinner) addSpinner.hidden = true;
      };
      addBtn.addEventListener('click', () => {
        if (addBtn.disabled) return;
        showLoading();
        setTimeout(hideLoading, 4000);
      }, true);
      ['cart:refresh', 'cart:open', 'cart:updated', 'qikify:cart:opened', 'qikify:cart:added', 'ajaxCart.afterCartLoad'].forEach(evt => {
        document.addEventListener(evt, hideLoading);
        window.addEventListener(evt, hideLoading);
      });
      form.addEventListener('submit', showLoading);
    }
  }
})();
